import { Component } from '@angular/core';
import BaseDetailPageConfig from '../../../../../models/base-detail-page.config';
import { RouteService } from '../../../../../services/route.service';
import { CustomerService } from '../../../../../services/api/customer.service';
import { BaseDetailPageComponent } from '../../../../../components/pages/base-detail-page/base-detail-page.component';

@Component({
  selector: 'app-customers-client-types-detail-page',
  imports: [BaseDetailPageComponent],
  templateUrl: './customers-client-types-detail-page.component.html',
  styleUrl: './customers-client-types-detail-page.component.scss'
})
export class CustomersClientTypesDetailPageComponent {
  baseDetailPageConfig!: BaseDetailPageConfig;
  readonlyClientTypesDetail: boolean

  clientType?: any;

  constructor(
    private customersService: CustomerService,
    private routeService: RouteService
  ) {
    this.readonlyClientTypesDetail = true
  }

  ngOnInit(): void {

    this.baseDetailPageConfig = {
      pageTitle: 'Item Types',
      cardTitle: 'Item Types Detail',
      editItemButton: {
        type: 'success',
        title: 'Edit Item Product',
        onClick: () => {
          this.routeService.customerSettingsClientTypesUpdate(this.clientType.customerTypeId);
        }
      },
      dataList: {
        data: null,
        rows: [
           {
            attribute: 'id',
            label: 'ID',
            value: (item: any) => {
              return item.customerTypeId;
            }
          },
          {
            attribute: 'code',
            label: 'Code',
            value: (item: any) => {
              return item.code;
            }
          },
          {
            attribute: 'name',
            label: 'Name',
            value: (item: any) => {
              return item.name;
            }
          },
           {
            attribute: 'createTime',
            label: 'Create Time',
            value: (item: any) => {
              return item.createTime;
            }
          },
        ]
      },
      apiDetailService: (clientTypeId: number) => this.customersService.detailSettingsClientsTypes(clientTypeId),
      routeParamName: 'clientTypeId',
      responseModelName: 'customerType'
    };

  }

  onLoadedDetail(data: any) {
    this.clientType = data;
  }
}
